import React, { useState } from 'react';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import { initStep3Data } from '../../ultis/objects/SignUp';
import { validateAccountId } from '../../ultis/regex/Regex';
import { useEffect } from 'react';
import { nextStep3 } from '../../redux/creates-action/SignUpAction';
import { useDispatch, useSelector } from 'react-redux'

export default function Step3() {
  const [values, setValues] = useState(initStep3Data(''))
  const [accountIdErrorText, setAccountIdErrorText] = useState('')
  const dispatch = useDispatch()
  const data3 = useSelector(state => state.signup.data.bankAccount)

  useEffect(() => {
    if (values.accountId !== '' && !values.isAccountIdError) {
      dispatch(nextStep3(values.accountId))
    }
  }, [values.accountId, dispatch])

  useEffect(() => {
    let data = {
      ...values,
      accountId: data3.accountId
    };
    setValues(data);
  }, [data3.accountId])

  const handleAccountIdChange = (event) => {
    let value = event.target.value;
    let data = handleValidateAccountId(value);
    setValues(data);
  }
  function handleValidateAccountId(accountId) {
    let result = validateAccountId(accountId);
    let data;
    if (!result) {
      data = { ...values, accountId: accountId, isAccountIdError: true };
      setValues(data);
      setAccountIdErrorText("Only Number");
    } else {
      data = { ...values, accountId: accountId, isAccountIdError: false };
      setValues(data);
      setAccountIdErrorText("");
    }
    return data;
  }


  return (
    <React.Fragment>
      <p style={{ textAlign: 'center', margin: '24px 0 48px 0', fontSize: '20px', fontWeight: '500', color: '#212529', fontFamily: 'Jost, sans-serif', }}>
        {/* Enter Bank Account for sign-up */}
      </p>
      <Grid container spacing={3} sx={{ alignItems: 'center' }}>
        <Grid item xs={4} sx={{ textAlign: 'right' }} >
          Account ID *
        </Grid>
        <Grid item xs={6}>
          <TextField
            fullWidth
            value={values.accountId}
            onChange={handleAccountIdChange}
            error={values.isAccountIdError}
            helperText={accountIdErrorText}
            variant="outlined"
          />
        </Grid>
        <Grid item xs={2}>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}